import {Component, Input, OnInit} from '@angular/core';
import {LibraryItem} from "../../../model/library";
import {Router} from "@angular/router";
import {ImageService} from "../../../services/image.service";
import {LibraryService} from "../../../services/library.service";
import {Subject, takeUntil} from "rxjs";
import {animate, style, transition, trigger,state} from '@angular/animations';

@Component({
  selector: 'library-item',
  templateUrl: './library-item.component.html',
  styleUrls: ['./library-item.component.less'],
  animations: [
    trigger('fadeSlide', [
      transition(':enter', [
        style({ height: '0px', opacity: 0, overflow: 'hidden' }),
        animate('300ms ease-out', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, overflow: 'hidden' }),
        animate('300ms ease-in', style({ height: '0px', opacity: 0 })),
      ]),
    ]),
  ],
})
export class LibraryItemComponent implements OnInit {

  @Input()
  libraryItem: LibraryItem;
  inBookingCart: boolean = false;

  showDEscription: boolean = false;

  private destroySubject: Subject<void> = new Subject();

  imageLink: string;

  constructor(
    private router: Router,
    public imageService: ImageService,
    public libraryService: LibraryService,
  ) {
  }

  ngOnInit(): void {

    this.imageLink = this.libraryItem.mainPhoto ? this.libraryItem.mainPhoto : this.libraryItem.imageLink;

    let filterItems = this.libraryService.getItemsFromBookStorage().filter((itm) => this.libraryItem.id == itm.id)
    this.inBookingCart = filterItems.length > 0;

    this.inBookingCart
    this.libraryService.bookingChange.pipe(
      takeUntil(this.destroySubject))
      .subscribe(event => {

        if (event?.id == this.libraryItem.id) {
          this.inBookingCart = true;
        }
      })
  }

  changeShowDescription() {
    this.showDEscription = !this.showDEscription
  }

  addToBooking() {
    this.libraryService.addItemToBookStorage(this.libraryItem);

  }

  ngOnDestroy() {
    this.destroySubject.next();
  }
}
